import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractService } from "../../commons/abstract.service";
import { SearchParams } from "../../commons/abstract.types";

@Injectable({ providedIn: 'root' })
export class CrmService extends AbstractService<any> {

  getURLBase(): string {
    return '/crm';
  }
  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: any): void {
    delete obj?._id;

  }
  preUpdate(obj: any): void {
  }

  getCrmMetrics(params?: Partial<SearchParams>) {
    let urling = `/metrics`;
    if (params) {
      for (let param in params) {
        urling = `${urling}${urling.includes('?') ? '&' : '?'}${param}=${params[param]}`;
      }
    }
    return super.get(urling);
  }

  getRevenueBySeller(params?: Partial<SearchParams>) {
    let urling = '/revenue-by-seller';
    if (params) {
      for (let param in params) {
        urling = `${urling}${urling.includes('?') ? '&' : '?'}${param}=${params[param]}`;
      }
    }
    return super.get(urling);
  }

  getOrderChart(params?: Partial<SearchParams>) {
    let urling = '';
    if (params) {
      for (let param in params) {
        const rawValue = params[param];
        const value = this.toUnixTimestamp(rawValue as string | number | Date);
        urling = `${urling}&${param}=${value}`;
      }
    }
    return super.get(`/orders-chart?${urling}`);
  }

  getCustomers(page: number, perPage: number, search?: string, params?: Partial<SearchParams>) {
    const baseURL = `/customers`
    const pager = `${baseURL}?page=${page}&perPage=${perPage}`;

    const getSearchConfig = (search: string): string => {
      if (!!search) {
        return '&search=' + encodeURIComponent(search);
      } else {
        return '';
      }
    }

    const searching = `${pager}${getSearchConfig(search)}`;

    let urling = `${searching}`;
    if (!!params) {
      for (let param in params) {
        const rawValue = params[param];
        const value = this.toUnixTimestamp(rawValue as string | number | Date);
        urling = `${urling}&${param}=${value}`;
      }
    }
    return super.get(urling);
  }

  getOrders(page: number, perPage: number, search?: string, params?: Partial<SearchParams>) {
    const baseURL = `/orders`
    const pager = `${baseURL}?page=${page}&perPage=${perPage}`;

    const getSearchConfig = (search: string): string => {
      if (!!search) {
        return '&search=' + encodeURIComponent(search);
      } else {
        return '';
      }
    }

    const searching = `${pager}${getSearchConfig(search)}`;

    let urling = `${searching}`;
    if (!!params) {
      for (let param in params) {
        const rawValue = params[param];
        const value = this.toUnixTimestamp(rawValue as string | number | Date);
        urling = `${urling}&${param}=${value}`;
      }
    }
    return super.get(urling);
  }

  private toUnixTimestamp(date: Date | string | number): number {
    if (typeof date === 'number') {
      return date;
    }
    if (typeof date === 'string') {
      const parsed = new Date(date);
      return isNaN(parsed.getTime()) ? 0 : parsed.getTime();
    }
    return date.getTime();
  }
}
